import { render, staticRenderFns } from "./ResultFormXhq.vue?vue&type=template&id=364734c0&scoped=true&"
import script from "./ResultFormXhq.vue?vue&type=script&lang=js&"
export * from "./ResultFormXhq.vue?vue&type=script&lang=js&"
import style0 from "./ResultFormXhq.vue?vue&type=style&index=0&id=364734c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364734c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('364734c0')) {
      api.createRecord('364734c0', component.options)
    } else {
      api.reload('364734c0', component.options)
    }
    module.hot.accept("./ResultFormXhq.vue?vue&type=template&id=364734c0&scoped=true&", function () {
      api.rerender('364734c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/IntelligentBooking/components/ResultFormXhq.vue"
export default component.exports